import cx from 'classnames';
import type * as React from 'react';
import { FormLabelHelper } from './form.label-helper';
import type { FormLabelBase } from './form.types';
import { Text } from '@dx-ui/global-ui-prism';

type FormLabel = FormLabelBase<HTMLLabelElement>;

const FormLabel: React.FC<React.PropsWithChildren<FormLabel>> = ({
  label,
  required,
  optional,
  hasError,
  className,
  children,
  type,
  size = 'md',
  ...rest
}) => {
  return (
    <label className={cx('label', className)} {...rest}>
      <Text
        as="span"
        size={size}
        className={cx({
          'font-bold': type !== 'checkbox' && type !== 'radio',
          'text-surface-error': hasError,
        })}
      >
        {label}
        <FormLabelHelper required={required} optional={optional} hasError={hasError} />
      </Text>
      {children}
    </label>
  );
};

export { FormLabel };
export default FormLabel;
